// extracted by mini-css-extract-plugin
module.exports = {"sideToggle":"SideToggle_sideToggle__2e_gQ"};